"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Dialog = {
  styles: function styles(theme) {
    return {
      defaultDialogBoxStyles: {
        border: "none",
        borderRadius: 12,
        background: theme.colors.pageBackground,
        padding: theme.spacing.base * 4
      },
      small: {
        padding: theme.spacing.base * 2
      },
      title: {
        color: theme.colors.baseContrast070,
        fontSize: theme.typography.fontSize + 4,
        fontWeight: 500,
        letterSpacing: 0.6,
        textTransform: "uppercase"
      },
      svgIcon: {
        width: 20,
        height: 20,
        minHeight: 20,
        minWidth: 20
      },
      content: {
        fontSize: theme.typography.fontSize
      },
      actions: {
        marginTop: theme.spacing.base * 2
      },
      button: {
        background: "none",
        borderColor: theme.colors.baseContrast100,
        border: "1px solid",
        "&:hover, &:focus-visible": {
          background: "none",
          borderColor: theme.colors.baseContrast060
        },
        "& label": {
          color: theme.colors.baseContrast085
        },
        "&:last-child > label": {
          color: theme.colors.baseContrast100
        },
        "&:last-child": {
          background: "linear-gradient(180deg, ".concat(theme.colors.primary, " 0%, ").concat(theme.colors.primaryDark, " 100%)"),
          border: "none",
          "&:hover, &:focus-visible": {
            background: "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(180deg, ".concat(theme.colors.primary, " 0%, ").concat(theme.colors.primaryDark, " 100%)"),
            "& label": {
              color: theme.colors.textOnDark
            }
          }
        }
      }
    };
  }
};
var _default = exports.default = Dialog;